module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3IGuM"))).then(() => parcelRequire('ikE14'));